export default "/images/vendor/flag-icons/flags/4x3/td.svg?ce35efd0cf28cc8886eb7ee531aef6d7";